import SideBar from '../sideBar';
import RightBar from './RightBar';
import VideoComponent from './videocomponent';
import MiddleController from './cardsControllers/middleController';
import ImageAnnotationTool from './ImageAnnotationTool';
// import FirstCard from './cardsControllers/firstCard';
import ThirdCard from './cardsControllers/thirdCard';
import Grid from '@mui/material/Grid';
import { useState, useRef, useEffect } from 'react';
import { IS_ANNOTATION } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';

const VideoPage = () => {
  const [source, setSource] = useState('');
  const isAnnotation = useSelector((state) => state.cameraReducer.isAnnotation);
  const checkImage = useSelector((state) => state.cameraReducer.checkImage);
  const targetRef = useRef(null);
  const dispatch = useDispatch();

  // const scrollToTarget = () => {
  //   // if (targetRef.current) {
  //   //   targetRef.current.scrollIntoView({ behavior: 'smooth' });
  //   //   document.body.style.cursor = 'crosshair'; // Change cursor style
  //   // }
  // };
  useEffect(() => {
    if (checkImage) {
      dispatch({ type: IS_ANNOTATION, isAnnotation: true });
    }
    // eslint-disable-next-line
  }, [checkImage]);
  return (
    <>
      <Grid container spacing={2}>
        {/* <Grid item md={1.7}></Grid> */}
        <SideBar selField="videos" />
        <Grid className='-mt-2.5' sx={{
          marginLeft: '30px',
        }} item md={12}>
          <div className=" flex gap-2 w-full mb-3">
            <div className="  w-full ">
              <div ref={targetRef} className="  w-full m-0 p-0">
                {isAnnotation ? <ImageAnnotationTool /> : <VideoComponent vdoSource={source} />}
              </div>
              <div className="flex mt-2 gap-1 mb-1 text-white">
                {/* <div className="w-1/3 h-[300px] bg-[#454545] rounded-lg ">
                  <FirstCard vdoSource={source} />
                </div> */}
                <div className="w-full h-[300px] bg-[#454545] rounded-lg">
                  <MiddleController />
                </div>
                <div className="w-1/3 h-[300px] bg-[#454545] rounded-lg">
                  <ThirdCard />
                </div>
              </div>
            </div>
            <div className="w-1/4">
              <RightBar videoSource={setSource} />
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default VideoPage;
